import { SUMMARY_REPORT_OBJECT_TYPE, summaryReportObjectTypeIconMap } from "Common/dictionaries/summaryReportObjectType";
import classNames from "classnames";
import get from "lodash/get";
import isArray from "lodash/isArray";
import map from "lodash/map";
import React from "react";
import { NAV_ITEM_ACTION_ELEMENT_IGNORE_STYLES_CLASS_NAME, SidebarMenuItem } from "../../Common";
export const buildSummaryReportObjectKey = (objId) => `summaryReportObject_${objId}`;
export default (summaryReportObjects, draggableType) => map(summaryReportObjects, o => {
    var _a;
    const e = new SidebarMenuItem(buildSummaryReportObjectKey(o.Id), o.Name, summaryReportObjectTypeIconMap[o.SummaryReportObjectType], undefined, o);
    e.draggableType = draggableType;
    e.draggableData = JSON.stringify(o);
    let count;
    if (o.SummaryReportObjectType === SUMMARY_REPORT_OBJECT_TYPE.DOCUMENT_OBJECT_NODES &&
        isArray(o.Value)) {
        count = o.Value.length;
    }
    else if (o.SummaryReportObjectType === SUMMARY_REPORT_OBJECT_TYPE.TABLE_ROWS &&
        isArray(get(o.Value, "Rows"))) {
        count = (_a = get(o.Value, "Rows")) === null || _a === void 0 ? void 0 : _a.length;
    }
    if (count) {
        e.actionElements = [
            React.createElement("div", { key: "count", className: classNames("bg-layers-primary-opacity-12 text-light-on-surface-variant border-rounded-4 font-small line-height-base pl-0_5 pr-0_5", NAV_ITEM_ACTION_ELEMENT_IGNORE_STYLES_CLASS_NAME) }, count)
        ];
    }
    return e;
});
